export const environment = {
  BASE_URL: "https://app.escozor.co.in/api/Api",
  BASE_URL2: "https://app.escozor.co.in/api/Api",

  // Public Key
  public_key: 'a',

  // Image Path fro the BaseURL from Backend

  // img_path: 'https://shivtrading.com.in/installer/api/uploads/'
  img_path: 'https://app.escozor.co.in/api/uploads/'
}
